enum SelectSizes {
    Base = "-base",
    Small = "-small",
}

export default SelectSizes;
